// @ts-nocheck





import {
  fetchRequest,
  initialFetchListParams,
  downloadRequestWithToken } from
'./index';

import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';
import { convertDataFromServer as convertDataFromServerGroupedList } from './executionBudget';

export const convertDataFromServer = (driverInspection) => ({
  ...driverInspection,
  paymentAmount: convertFromKopToRub(driverInspection.paymentAmount)
});

export const convertDataToServer = (driverInspection) => ({
  ...driverInspection,
  paymentAmount: convertFromRubToKop(driverInspection.paymentAmount)
});

export const addDriverInspection = async (
driverInspection) =>
{
  const added = await fetchRequest.post(
    '/driverInspection',
    convertDataToServer(driverInspection)
  );
  if (added) return convertDataFromServer(driverInspection);
  throw new Error('Не удалось создать осмотр водителей');
};

export const updateDriverInspection = async (
driverInspection) =>
{
  const updated = await fetchRequest.put(
    '/driverInspection',
    convertDataToServer(driverInspection)
  );
  if (updated) return convertDataFromServer(updated);
  throw new Error('Не удалось обновить осмотр водителей');
};
export const deleteDriverInspection = async (
id) =>
{
  const deleted = await fetchRequest.delete(`/driverInspection/${id}`);
  if (deleted) return convertDataFromServer(deleted);
  throw new Error('Не удалось удалить осмотр водителей');
};

export const fetchDriverInspection = async (
id,
params = {}) =>
{
  const driverInspection = await fetchRequest.get(
    `/driverInspection/${id}`,
    params
  );
  if (driverInspection) return convertDataFromServer(driverInspection);
  throw new Error('Не удалось получить список осмотра водителей');
};

export const fetchVehicleDriverInspections = async (
vehicleId,
params = initialFetchListParams) =>
{
  const driverInspections = await fetchRequest.get(
    `/driverInspection/vehicle/${vehicleId}`,
    {
      ...initialFetchListParams,
      ...params
    }
  );
  if (driverInspections) {
    return {
      ...driverInspections,
      data: driverInspections.data.map(convertDataFromServer)
    };
  }
  throw new Error('Не удалось получить список осмотра водителей');
};

export const fetchDriverInspections = async (
params = initialFetchListParams) =>
{
  const driverInspections = await fetchRequest.get('/driverInspection', {
    ...initialFetchListParams,
    ...params
  });
  if (driverInspections) {
    return {
      ...driverInspections,
      data: driverInspections.data.map(convertDataFromServer)
    };
  }
  throw new Error('Не удалось получить список осмотра водителей');
};

export const groupedList = async (
params = {}) =>
{
  const groupedList = await fetchRequest.get(
    `/driverInspection/groupedList`,
    params
  );
  if (groupedList)
  return {
    ...groupedList,
    data: groupedList.data.map(convertDataFromServerGroupedList)
  };
  throw new Error(
    'Не удалось получить сгруппированный список для исполнения бюджета'
  );
};

export const printReport = async (
params,
fileName) =>
{
  const isPrinted = await downloadRequestWithToken(
    '/driverInspection/print',
    params,
    fileName
  );
  if (isPrinted) return true;
  throw new Error('Не удалось загрузить отчет');
};

export default {
  groupedList,
  addDriverInspection,
  updateDriverInspection,
  deleteDriverInspection,
  fetchDriverInspection,
  fetchVehicleDriverInspections,
  fetchDriverInspections,
  printReport
};
